import classNames from "classnames";

interface ICiroRadioButtonProps {
  isSelected: boolean;
  label: string;
  setIsSelected: () => void;
}

const CiroRadioButton = ({
  isSelected,
  label,
  setIsSelected,
}: ICiroRadioButtonProps) => {
  return (
    <label
      className={classNames(
        "inline-flex",
        "items-center",
        "cursor-pointer",
      )}
    >
      <input
        type="radio"
        className={classNames("hidden")}
        checked={isSelected}
        onClick={setIsSelected}
      />
      <span
        className={classNames(
          "w-5",
          "h-5",
          "border-2",
          "rounded-full",
          "mr-2",
          {
            "bg-amber-500/30": isSelected,
            "border-orange-400": isSelected,
            "border-gray-300": !isSelected,
          },
        )}
      ></span>
      <span>{label}</span>
    </label>
  );
};

export default CiroRadioButton;
